// extracted by mini-css-extract-plugin
export default {"tabs":"TabsComponent_tabs__ToCjQ","tabList":"TabsComponent_tabList__twJa7","tab":"TabsComponent_tab__-pVl1","active":"TabsComponent_active__yTuZU"};